import { BrowserHistory } from "history";
import { unsavedChangesDialog } from "../business-components/common/unsavedChanges";
import { routerStore } from "./WSRouter";
import { UnsavedChangesStrategy } from "./MobxReactRouter";

export function blockNavigation(
  browserHistory: BrowserHistory,
  unblock: () => void,
  onNewUnblocker: (blocker: any) => void
) {
  function getUnsavedChangesStrategy(): UnsavedChangesStrategy {
    const override = routerStore.unsavedChangesStrategy;

    if (override) {
      return override;
    }

    return UnsavedChangesStrategy.check;
  }

  async function shouldNavigate() {
    const strategy = getUnsavedChangesStrategy();

    if (strategy === "check") {
      return {
        navigate: !!(await unsavedChangesDialog()),
        strategy,
      };
    }

    return {
      navigate: true,
      strategy,
    };
  }

  function createNewBlocker() {
    return browserHistory.block(async (blocker) => {
      const { navigate, strategy } = await shouldNavigate();

      if (!navigate) {
        // keep it blocked
        return;
      }

      if (strategy === UnsavedChangesStrategy.forget) {
        // unblock and navigate
        unblock();
        blocker.retry();
        return;
      }

      if (strategy === UnsavedChangesStrategy.ignore) {
        // unblock, navigate and reblock
        unblock();
        blocker.retry();
        onNewUnblocker(createNewBlocker());
        return;
      }

      if (strategy === UnsavedChangesStrategy.check) {
        // unblock, navigate
        unblock();
        blocker.retry();
        return;
      }
    });
  }

  onNewUnblocker(createNewBlocker());
}
